import { ThinEngine } from "../../Engines/thinEngine";
import type { Nullable } from "../../types";

import type { TextureSampler } from "../../Materials/Textures/textureSampler";

declare module "../../Engines/thinEngine" {
    export interface ThinEngine {
        /**
         * Sets a texture sampler to the according uniform.
         * @param name The name of the uniform in the effect
         * @param sampler The sampler to apply
         */
        setTextureSampler(name: string, sampler: Nullable<TextureSampler>): void;
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
ThinEngine.prototype.setTextureSampler = function (name: string, sampler: Nullable<TextureSampler>): void {
    throw new Error("setTextureSampler: This engine does not support separate texture sampler objects!");
};
